import React from 'react';
import {Card,CardHeader,CardContent} from '@material-ui/core';
import {TwitterTimelineEmbed} from 'react-twitter-embed';
import { lang } from '../../../config/app.config';
// import translates from '../../../translation.json';
import { useSelector } from 'react-redux';

const TwitterFeeds =  ()=>{
  const state = useSelector((state)=>state.translation);

  return(
    <Card>
      <CardHeader title={state.translation?state.translation.twitter_feeds[lang === 'np'?'value_np':'value_en']:''} className="card-header-primary"/>
      <CardContent className="bg-primary custom-card-body">
        <div style={{
          height:'400px',overflow:'auto'
        }}>
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName="ECNOfficial"
            options={{height: 400}}
          />  
        </div>
      </CardContent>
    </Card>
  );
}

export default TwitterFeeds;
